document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  const initializeExpandableCards = () => {
    const cards = document.querySelectorAll('.fw-expand-card');

    cards.forEach((card) => {
      const expandedContent = card.querySelector('.fw-expand-card__more');

      if (!expandedContent) {
        return;
      }

      const tagName = card.tagName.toLowerCase();
      const naturallyFocusable = tagName === 'a' || tagName === 'button';

      const focusableChild = card.querySelector(
        'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'
      );

      if (
        !naturallyFocusable &&
        !focusableChild &&
        !card.hasAttribute('tabindex')
      ) {
        card.setAttribute('tabindex', '0');
      }
    });
  };

  const updateQuoteCtaState = () => {
    if (!body.classList.contains('template-index')) {
      body.classList.add('fw-scrolled-past-quote');
      return;
    }

    const heroQuoteButton = document.querySelector('.fw-hero .fw-button');
    const header = document.querySelector('.fw-header');

    if (!heroQuoteButton || !header) {
      body.classList.add('fw-scrolled-past-quote');
      return;
    }

    const buttonBottom = heroQuoteButton.getBoundingClientRect().bottom;
    const headerBottom = header.getBoundingClientRect().bottom;

    if (buttonBottom <= headerBottom) {
      body.classList.add('fw-scrolled-past-quote');
    } else {
      body.classList.remove('fw-scrolled-past-quote');
    }
  };

  initializeExpandableCards();
  updateQuoteCtaState();

  window.addEventListener('scroll', updateQuoteCtaState, { passive: true });
  window.addEventListener('resize', updateQuoteCtaState);
});